import Swiper from 'swiper';

export default class Slider {
  constructor(selector, options = {}) {
    this.selector = selector;

    this.options = {
      ...{
        grabCursor: true,
        preventClicks: true,
        preventClicksPropagation: true,
        preventInteractionOnTransition: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        enabled: true,
      },
      ...options,
      // ...{
      //   modules: [...options.modules, Keyboard],
      // },
    };

    this.checkActive();
    window.addEventListener('resize', this.checkActive.bind(this));
  }

  checkActive() {
    let breakpoint = 0;
    if (this.options.breakpoints) {
      const breakpoints = Object.keys(this.options.breakpoints);
      const smallestWidth = Math.min(window.outerWidth, window.innerWidth);

      breakpoint = breakpoints
        .filter((breakpoint) => smallestWidth > breakpoint)
        .sort((a, b) => a - b)
        .slice(-1)[0];
    }

    if (this.options.breakpoints && breakpoint) {
      if (this.options.breakpoints[breakpoint]) {
        if (this.options.breakpoints[breakpoint].enabled === false) {
          return this.disable();
        } else {
          return this.enable();
        }
      }
    }

    if (this.options.enabled === false) {
      return this.disable();
    }

    return this.enable();
  }

  enable() {
    if (this.swiper) return;
    this.addSliderClasses();
    this.swiper = new Swiper(this.selector, this.options);
  }

  disable() {
    if (!this.swiper) return;
    if (this.swiper.destroyed) return;

    if (this.swiper.length > 1) {
      this.swiper.forEach((swiper) => {
        swiper.destroy(true, true);
      });
    } else {
      this.swiper.destroy(true, true);
    }

    this.swiper = null;
    this.removeSliderClasses();
  }

  addSliderClasses() {
    $(this.selector).find('> * > .col-slide').addClass('swiper-slide');
  }

  removeSliderClasses() {
    $(this.selector).removeClass('swiper-backface-hidden');
    $(this.selector).find('> * > .col-slide').removeClass('swiper-slide');
  }
}
